import {ModalTiteledWindow} from "./modalWindow.js";
import {DataView} from '../dataview.js';

export class ModalSelectPupil extends ModalTiteledWindow {

   constructor(settings, callback, dm, multiSelect) {
      super();
      this.dm = dm;
      this.callback = callback;
      this.multiSelect = multiSelect === undefined ? true : multiSelect;
      this.load(settings);
   }

   load(settings) {

      this.ignoreList = settings.ignore || [];

      const tmpl = document.getElementById('tpl-modal-select-pupil');
      const container = tmpl.content.cloneNode(true);
      container.querySelector('.ok').addEventListener('click', () => {
         const pupilIds = this.list.getMultiActionItems().map(pupil => pupil.id);
         if (pupilIds.length > 0) {
            this.callback(pupilIds);
            this.close();
         }
      });


      this.list = new DataView(container.querySelector('.list'));

      if (settings.hasOwnProperty('list')) {
         container.querySelector('.classes').hidden = '';
         this.loadPupils(settings.list);
      }
      else if (settings.hasOwnProperty('classes')) {

         const classes = container.querySelector('.classes');

         for (const cls of settings.classes) {
            let btn = classes.createElement('div', 'select-class');
            btn.setStyles({ display: 'inline-block', backgroundColor: '#3A78FF', borderRadius: '40%', padding: '.3rem 1rem', marginRight: '.2rem', color: '#333', fontWeight: 'bold' });
            btn.innerHTML = this.dm.getClass(cls).name;
            btn.dataset.classId = cls;
            btn.addEventListener('click', event => {
               event.stopPropagation();
               event.target.parentNode.querySelectorAll('.select-class').removeClass('selected');
               event.target.classList.add('selected');
               this.loadPupilsOfClass(parseInt(event.currentTarget.dataset.classId));
            });
         }

         let btn = classes.createElement('div', 'select-class');
         btn.setStyles({ display: 'inline-block', backgroundColor: '#3A78FF', borderRadius: '40%', padding: '.3rem 1rem', marginRight: '.2rem', color: '#333', fontWeight: 'bold' });
         btn.innerHTML = 'alle';
         btn.addEventListener('click', event => {
            event.stopPropagation();
            event.target.parentNode.querySelectorAll('.select-class').removeClass('selected');
            event.target.classList.add('selected');
            this.loadAllPupils();
         });

      }

      this.setTitle('Schüler auswählen');
      this.appendToBody(container);

      //this.panel.querySelector('table tr.footer').style.display = 'none';

      setTimeout(() => this.show(), 1);


   }

   loadPupilsOfClass(classId) {
      const cls = this.dm.getClass(classId);
      this.loadPupils(cls.pupils);
   }

   loadAllPupils() {
      let pupils = [];
      for (const cls of Object.values(this.dm.classes)) pupils = [...pupils, ...cls.pupils];
      this.loadPupils(pupils);
   }

   loadPupils(pupilIds) {

      let pupils = pupilIds.filter(id => { return !this.ignoreList.includes(id); }).map(id => { return this.dm.getPupil(id) });

      var listSettings = {
         columns: [
            {
               title: 'Nachname',
               data: 'lastName',
               sort: { index: 1, dir: 1 },
               css: { height: '2.5rem' }
            },
            {
               title: 'Vorname',
               data: 'firstName',
               sort: { index: 2, dir: 1 }
            },
            {
               title: 'Klasse',
               data: (pupil) => {
                  return pupil.class.name;
               },
               sort: { index: 3, dir: 1, value: function(pupil) {
                  return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
               }}

            }
         ],
         /*
         multiAction: {
            buttons: []
         },
         */
         onSelected: (pupil) => {
            this.callback([pupil.id]);
            this.close();
         },
         itemCSS: () => { return { minHeight: '4rem' }; },
         showHeader: true,

      };

      if (this.multiSelect) {
         listSettings.multiAction = { buttons: [] };
      }

      this.list.load(pupils, listSettings);


   }

}
